import React, { useRef, useState } from "react";
import { Quote, Star, Play, ShieldCheck, Lock } from "lucide-react";

const ROOFTOP_IMG = "https://customer-assets.emergentagent.com/job_create-snap/artifacts/rn08omlj_asset-b70a943c-a581-4dfd-b8da-8a310f5cfbd1.jpg";
const VIDEO_SRC = "https://customer-assets.emergentagent.com/job_create-snap/artifacts/alpzjp5a_asset-1955b309-2a43-4201-9e6e-94853fed8df5.mov";

const VideoTile = () => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const toggle = () => {
    const v = ref.current;
    if (!v) return;
    if (v.paused) { v.play(); setPlaying(true); }
    else { v.pause(); setPlaying(false); }
  };
  return (
    <div className="snap-card p-0 overflow-hidden">
      <div className="relative bg-black aspect-[4/5]">
        <video ref={ref} src={VIDEO_SRC} className="w-full h-full object-cover" playsInline preload="metadata" onEnded={() => setPlaying(false)} />
        <button type="button" onClick={toggle} aria-label="Play testimonial" className="absolute inset-0 flex items-center justify-center group">
          {!playing && (
            <span className="w-16 h-16 rounded-full bg-[#3B9EFF] text-white flex items-center justify-center shadow-[0_0_30px_rgba(59,158,255,0.6)] group-hover:scale-110 transition-transform">
              <Play size={24} fill="currentColor" />
            </span>
          )}
        </button>
        <span className="absolute top-3 left-3 pill text-[10px]">VIDEO REVIEW</span>
      </div>
      <div className="p-5">
        <div className="flex items-center gap-1 text-[#3B9EFF]">
          {Array.from({ length: 5 }).map((_, k) => <Star key={k} size={13} fill="currentColor" />)}
        </div>
        <p className="text-white text-sm mt-2 leading-relaxed">"So impressed with the video quality and product."</p>
        <p className="text-[#A0AABF] text-xs mt-2">Claudio · Rooftop Solutions</p>
      </div>
    </div>
  );
};

export const CheckoutSocialProof = ({ price = 99.99 }) => {
  return (
    <div className="mt-7 max-w-2xl" data-testid="checkout-social-proof">
      {/* Trust bar */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2 text-sm text-[#A0AABF]">
          <div className="flex items-center gap-0.5 text-[#3B9EFF]">
            {Array.from({ length: 5 }).map((_, k) => <Star key={k} size={14} fill="currentColor" />)}
          </div>
          <span className="text-white font-semibold">4.9</span>
          <span>from real owners</span>
        </div>
        <div className="flex items-center gap-1.5 text-sm text-[#A0AABF]">
          <ShieldCheck size={14} className="text-[#3B9EFF]" /> Secure checkout
        </div>
      </div>

      {/* Testimonials row — bigger so it doesn't get dwarfed by the plan tiles above */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="snap-card p-0 overflow-hidden">
          <div className="relative aspect-[4/5] bg-[#0B111D]">
            <img src={ROOFTOP_IMG} alt="Rooftop Solutions content" className="w-full h-full object-cover" style={{ objectPosition: "center top" }} loading="lazy" />
            <span className="absolute top-3 left-3 pill text-[10px]">ROOFING</span>
            <div className="absolute bottom-0 inset-x-0 h-1/3 bg-gradient-to-t from-[#080C14] to-transparent" />
          </div>
          <div className="p-5">
            <Quote className="text-[#3B9EFF]" size={18} />
            <p className="text-white text-sm mt-2 leading-relaxed">"Closed 4 new jobs from Instagram last month."</p>
            <p className="text-[#A0AABF] text-xs mt-2">Claudio · Rooftop Solutions, FL</p>
          </div>
        </div>
        <VideoTile />
      </div>

      {/* Trust badges */}
      <div className="mt-5 grid grid-cols-3 gap-3 text-center">
        <div className="snap-card p-4">
          <p className="font-display font-black text-[#3B9EFF] text-2xl leading-none">72–96h</p>
          <p className="text-[11px] text-[#A0AABF] font-accent mt-1.5 tracking-wider">DELIVERY</p>
        </div>
        <div className="snap-card p-4">
          <p className="font-display font-black text-[#3B9EFF] text-2xl leading-none">${price}</p>
          <p className="text-[11px] text-[#A0AABF] font-accent mt-1.5 tracking-wider">FLAT PRICE</p>
        </div>
        <div className="snap-card p-4">
          <p className="font-display font-black text-[#3B9EFF] text-2xl leading-none">0</p>
          <p className="text-[11px] text-[#A0AABF] font-accent mt-1.5 tracking-wider">CALLS / MEETINGS</p>
        </div>
      </div>

      {/* Payment trust */}
      <div className="mt-5 flex items-center justify-center gap-2 text-xs text-[#A0AABF]">
        <Lock size={12} className="text-[#3B9EFF]" />
        <span>Encrypted by Square · Apple Pay · Google Pay · Cash App accepted</span>
      </div>
    </div>
  );
};

export default CheckoutSocialProof;
